import { forwardRef } from "react";

import { cn } from "@/lib/utils";

import type { TTextareaProps } from "./ui/textarea";
import { Textarea } from "./ui/textarea";

export interface IStyledTextareaProps extends TTextareaProps {
  wrapperClassName?: string;
  isError?: boolean;
  children?: React.ReactNode;
}

export const StyledTextarea = forwardRef<
  HTMLTextAreaElement,
  IStyledTextareaProps
>(({ wrapperClassName, className, isError, children, ...props }, ref) => {
  return (
    <div className={cn("relative", wrapperClassName)}>
      <Textarea
        ref={ref}
        className={cn(
          "bg-input-background min-h-[120px] focus-visible:ring-1 focus-visible:ring-offset-0 focus-visible:border-ring resize-y",
          isError &&
            "border-destructive focus-visible:border-destructive focus-visible:ring-destructive",
          className,
        )}
        {...props}
      />
      {children}
    </div>
  );
});

StyledTextarea.displayName = "StyledTextarea";
